/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import { Button, Container } from '@material-ui/core'
import { useKeycloak } from '@react-keycloak/web'
import Widget from '../Dashboard/Widget/Widget'
import { useStyles } from './Styles'
import Logo from '../Logo'

const Anonymous = ({ locale }) => {
  const { keycloak, initialized } = useKeycloak()
  const login = useCallback(() => {
    let refs = keycloak?.createAccountUrl().split('?')[1]
    let newUrl = keycloak?.createLoginUrl({ locale: locale }) + '&' + refs
    window.location.href = newUrl
  }, [keycloak, locale])

  const classes = useStyles()
  return (
    <div className={classes.AnonymousWrapper}>
      <Container maxWidth={'sm'} className={classes.AnonymousContainer}>
        <div>
          <Widget
            upperTitle
            disableWidgetMenu
            bodyClass={classes.AnonymousWidget}
          >
            <Logo/>
            <p><FormattedMessage id='AnonymousAuth.message'/></p>
            <div className={classes.headerAuthWrapper + (!initialized ? ' hidden' : '')}>
              <FormattedMessage id='AnonymousAuth.message.please'/>
              <Button disableElevation disableRipple onClick={login} className={classes.headerAuthLink}>
                <FormattedMessage id='HeaderAuth.link.login'/>
              </Button>
            </div>
          </Widget>
        </div>
      </Container>

    </div>
  )
}

export default Anonymous
